import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { jwtDecode } from "jwt-decode";

const obtenerIdDelToken = (token) => {
  const decodedToken = jwtDecode(token);
  // console.log("Data del token:", decodedToken);
  return decodedToken.id;
};

function Welcome() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userIsLoggedIn = localStorage.getItem("userId") !== null;
    const tokenOn = localStorage.getItem("token") !== null;
    // console.log("El token es " + localStorage.getItem("token"));

    // Actualiza el estado isLoggedIn
    setIsLoggedIn(tokenOn);

    if (tokenOn) {
      const token = localStorage.getItem("token");
      const userId = obtenerIdDelToken(token);
      setUser(userId);
      // navigate(`/home/${userId}`);
      navigate(`/home`);
    } else {
      navigate("/welcome");
    }

    // // Actualiza el estado isLoggedIn
    // setIsLoggedIn(userIsLoggedIn);

    // if (userIsLoggedIn) {
    //   setUser(JSON.parse(localStorage.getItem("userId")));
    // }
    // Navega a la ruta adecuada
    // if (tokenOn /*userIsLoggedIn*/) {
    //   console.log(user);
    //   navigate(`/home/${localStorage.getItem("userId")}`);
    // } else {
    //   navigate("/login"); // Sacar esto si queres que muestre algo el Welcome
    // }
  }, [navigate]);

  return <div>{/* Contenido del componente */}</div>;
}

export default Welcome;
